import { IUnitToPen } from "shared/api/api";

export const GET_UnitToPenData = 'GET_UnitToPenData';
export const SAVE_UnitToPen = 'SAVE_UnitToPen';

export interface UnitToPenDataState {
    data: IUnitToPen[];
    lastSyncDate?: Date;
}
